<template>
  <div>
    <v-data-table :headers="headers" :items="rawData" class="elevation-1" hide-actions>
      <template #items="props">
        <DataItem
          v-model="props.item"
          @onRefetchData="handleRefetchData"
          @handleRefreshData="handleRefreshData"
        />
      </template>
    </v-data-table>
    <v-layout row wrap justify-end class="mt-3">
      <v-pagination
        v-model="pageNumber"
        :length="pageCount"
        @input="handleChangePage"
      ></v-pagination>
    </v-layout>
  </div>
</template>

<script>
import nongtungjaiApi from '@/api/nongtungjai'
import { mapGetters } from 'vuex'
import DataItem from './DataItem.vue'
import * as XLSX from 'xlsx'

export default {
  components: {
    DataItem
  },
  props: {
    filters: {
      type: Object,
      default: () => {}
    },
    isExport: {
      type: Date,
      default: null
    }
  },
  data() {
    return {
      pageNumber: 1,
      rowPerPage: 10,
      offset: 0,
      total: 0,
      rawData: [],
      headers: [
        { text: '', value: '', align: 'center', sortable: false, width: '64px;' },
        { text: 'ชื่อ-นามสกุล', value: '', sortable: false, width: '300px' },
        { text: 'คะแนน ASSIST', value: '', sortable: false },
        { text: 'ระดับความเสี่ยง', value: '', sortable: false },
        { text: 'สถานะ', value: '', sortable: false },
        { text: 'หมายเหตุ', value: '', sortable: false }
      ],
      isExportFile: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pageCount() {
      if (this.total) {
        const total = parseFloat(this.total)
        return Math.ceil(total / this.rowPerPage)
      } else {
        return 1
      }
    }
  },
  watch: {
    filters: {
      handler() {
        this.handleFetchData()
      },
      deep: true
    },
    isExport(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.handleExportFile()
      }
    }
  },
  mounted() {
    this.handleFetchData()
  },
  methods: {
    async handleRefreshData() {
      const vm = this
      try {
        await vm.getSelfReferral()
      } catch (error) {
        console.error(error)
      } finally {
        vm.$store.dispatch('clear_loading')
      }
    },
    async handleFetchData() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await vm.getSelfReferral()
        vm.$store.dispatch('clear_loading')

        if (response && response.status === 200) {
          vm.rawData = response.data.data
          vm.total = response.data.total
        }
      } catch (error) {
        console.error(error)
      } finally {
        vm.$store.dispatch('clear_loading')
      }
    },
    async getSelfReferral() {
      const vm = this
      try {
        console.log('pageNumber: ', vm.pageNumber)
        const params = {
          page_id: vm.selectedBot.pageid,
          limit: vm.isExportFile ? vm.total : vm.rowPerPage,
          offset: vm.offset
        }

        if (vm.filters) {
          Object.keys(vm.filters).forEach((key) => {
            if (vm.filters[key] !== '') {
              Object.assign(params, { [key]: vm.filters[key] })
            }
          })
        }

        const response = await nongtungjaiApi.getSelfReferral({ params })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    goToLivechat: function (user, app) {
      let routeData = this.$router.resolve({
        name: 'livechat',
        path: '/' + this.currentLang + '/livechat',
        query: {
          userid: user.userid,
          user: user.context == 'contactadmin' ? 'admin' : 'bot',
          app: app
        }
      })
      window.open(routeData.href, '_blank')
    },
    handleChangePage(page) {
      this.pageNumber = page
      this.offset = this.pageNumber > 1 ? (this.pageNumber - 1) * this.rowPerPage : 0
      this.handleFetchData()
    },
    async handleExportFile() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        vm.offset = 0
        vm.pageNumber = 1
        vm.isExportFile = true
        const response = await vm.getSelfReferral()
        const data = response && response.data ? response.data.data : null
        vm.isExportFile = false

        if (data === null) return

        const json = data.map((el) => {
          let tempStatus = ''
          if (el.status) {
            if (el.status === 'not_processed') {
              tempStatus = 'ยังไม่ได้ดำเนินการ'
            } else if (el.status === 'waiting') {
              tempStatus = 'รอติดต่อกลับ'
            } else if (el.status === 'contacted') {
              tempStatus = 'ติดต่อแล้ว'
            }
          }

          let tempRisk = ''
          if (el.risk) {
            if (el.risk === 'low') {
              tempRisk = 'ความเสี่ยงต่ำ'
            } else if (el.risk === 'medium') {
              tempRisk = 'ความเสี่ยงปานกลาง'
            } else if (el.risk === 'high') {
              tempRisk = 'ความเสี่ยงสูง'
            }
          }

          return {
            drinker_name: el.drinker_name || '-',
            age: el.age ? el.age : '-',
            drinker_gender: el.drinker_gender
              ? el.drinker_gender === 'male'
                ? 'ชาย'
                : 'หญิง'
              : '-',
            filler_phone_no: el.filler_phone_no || '-',
            score: el.score,
            risk: tempRisk || '-',
            status: tempStatus || '-',
            note: el.note || '-'
          }
        })

        const heading = [
          [
            'ชื่อ-นามสกุล',
            'อายุ',
            'เพศ',
            'เบอร์โทร',
            'คะแนน ASSIST',
            'ระดับความเสี่ยง',
            'สถานะ',
            'หมายเหตุ'
          ]
        ]

        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.json_to_sheet([])
        XLSX.utils.sheet_add_aoa(ws, heading)
        XLSX.utils.sheet_add_json(ws, json, { origin: 'A2', skipHeader: true })
        XLSX.utils.book_append_sheet(wb, ws)
        XLSX.writeFile(wb, `self-referral-services.xlsx`)
        vm.$store.dispatch('clear_loading')
      } catch (error) {
        console.error(error)
      } finally {
        vm.$store.dispatch('clear_loading')
      }
    },
    handleRefetchData() {
      this.offset = 0
      this.pageNumber = 1
      this.handleFetchData()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/NongTungJai/SelfReferral/DataTable.vue